import { PrimaryButton } from "@graffer-inc/console-design-kit";
import React from "react";
import { RBACHidden } from "../../../helpers/rbac/rbac";

export const MainMenu: React.FC<{
  onStartCreation: () => void;
}> = ({ onStartCreation }) => {
  return (
    <div className="columns">
      <div className="column buttons">
        <RBACHidden requirePermissions="proc_management.procedure_tags.create">
          <PrimaryButton
            text="＋手続きタグを新規作成"
            onClick={onStartCreation}
          />
        </RBACHidden>
      </div>
    </div>
  );
};
